// extracted by mini-css-extract-plugin
module.exports = {"Title":"FAQ_Title__3s7Cg","text":"FAQ_text__10t7q"};